import { render, staticRenderFns } from "./CustomerSuggestionModule.vue?vue&type=template&id=2575c9ab&scoped=true"
import script from "./CustomerSuggestionModule.vue?vue&type=script&lang=js"
export * from "./CustomerSuggestionModule.vue?vue&type=script&lang=js"
import style0 from "./CustomerSuggestionModule.vue?vue&type=style&index=0&id=2575c9ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2575c9ab",
  null
  
)

export default component.exports